import React from "react";
import PropTypes from "prop-types";

import Strf from "shared/components/Strf";

// Show this when the person's inbox is full.
const FullInboxBannerMessage = ({ name }) => (
	<Strf vars={{
		warning: (
			<span role="img" aria-label="Warning">⚠️</span>
		),
		name,
	}}>
		$warning $name has a full inbox!
	</Strf>
);
FullInboxBannerMessage.propTypes = {
	name: PropTypes.string.isRequired,
};

export default FullInboxBannerMessage;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/FullInboxBanner.jsx